export function findCookieValueByKey(cookie: string, key: string): string | null {
    const values = cookie.split('; ').filter((cookie) => cookie.startsWith(`${key}=`));

    if (values.length === 0) {
        return null;
    } else if (values.length === 1) {
        return values[0].substring(key.length + 1);
    } else {
        console.warn('Multiple values for same cookie key found!');
        return values[0].substring(key.length + 1);
    }
}
